import { createContext } from 'react';

export const MOBILE_BREAKPOINT = 640;
export const TABLET_BREAKPOINT = 768;

export const getDeviceFlags = ({
  innerWidth,
  innerHeight,
}: {
  innerWidth: number;
  innerHeight: number;
}) => ({
  width: innerWidth,
  height: innerHeight,
  isMobile: innerWidth < MOBILE_BREAKPOINT,
  isTablet: innerWidth >= MOBILE_BREAKPOINT && innerWidth < TABLET_BREAKPOINT,
  isDesktop: innerWidth >= TABLET_BREAKPOINT,
});

export const deviceContext = createContext(getDeviceFlags(window));
